import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class UserValidName {
  value: boolean = false

  constructor(
    data: {
      value: boolean
    } | null = null,
  ) {
    if (data) {
      this.value = Boolean(data.value)
    }
  }
}
